"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInsightDrillConfigPanel = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../../model");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var drillConfigMapper_1 = require("./drillConfigMapper");
var useDrillConfigIncompleteItems_1 = require("./useDrillConfigIncompleteItems");
var messages = react_intl_1.defineMessages({
    added: { id: "messages.drill.InteractionConfiguredSuccess" },
    modified: { id: "messages.drill.InteractionUpdatedSuccess" },
});
var mergeDrillConfigItems = function (drillConfigItems, incompleteItems) {
    return incompleteItems.reduce(function (acc, incompleteItem) {
        var found = acc.findIndex(function (item) { return item.localIdentifier === incompleteItem.localIdentifier; });
        if (found !== -1) {
            if (!incompleteItem.complete) {
                acc[found] = incompleteItem;
            }
        }
        else {
            acc.push(incompleteItem);
        }
        return acc;
    }, tslib_1.__spread(drillConfigItems));
};
var getUnusedDrillTargets = function (availableDrillTargets, mergedItems) {
    var _a, _b;
    var availableDrillTargetMeasures = (_a = availableDrillTargets === null || availableDrillTargets === void 0 ? void 0 : availableDrillTargets.measures) === null || _a === void 0 ? void 0 : _a.filter(function (measure) {
        return !mergedItems.some(function (item) {
            return item.type === "measure" &&
                item.localIdentifier === measure.measure.measureHeaderItem.localIdentifier;
        });
    });
    var availableDrillTargetAttributes = (_b = availableDrillTargets === null || availableDrillTargets === void 0 ? void 0 : availableDrillTargets.attributes) === null || _b === void 0 ? void 0 : _b.filter(function (attribute) {
        return !mergedItems.some(function (item) {
            return item.type === "attribute" &&
                item.localIdentifier === attribute.attribute.attributeHeader.localIdentifier;
        });
    });
    return {
        measures: availableDrillTargetMeasures,
        attributes: availableDrillTargetAttributes,
    };
};
/**
 * hook for DrillConfigPanel component
 * @internal
 */
exports.useInsightDrillConfigPanel = function (props) {
    var widgetRef = props.widgetRef;
    var widget = model_1.useDashboardSelector(model_1.selectWidgetByRef(widgetRef));
    ts_invariant_1.default(sdk_model_1.isInsightWidget(widget), "must be insight widget");
    var widgetDrills = widget.drills;
    var _a = useDrillConfigIncompleteItems_1.useIncompleteItems({ widgetDrills: widgetDrills }), incompleteItems = _a.incompleteItems, deleteIncompleteItem = _a.deleteIncompleteItem, onChangeItem = _a.onChangeItem, onOriginSelect = _a.onOriginSelect, completeItem = _a.completeItem, isItemNew = _a.isItemNew;
    var addSuccess = sdk_ui_kit_1.useToastMessage().addSuccess;
    var dispatch = model_1.useDashboardDispatch();
    var configItems = model_1.useDashboardSelector(model_1.selectDrillTargetsByWidgetRef(widgetRef));
    var invalidCustomUrlDrillLocalIds = model_1.useDashboardSelector(model_1.selectInvalidUrlDrillParameterDrillLocalIdsByWidgetRef(widgetRef));
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var enableKDZooming = settings.enableKDZooming;
    var availableDrillTargets = configItems === null || configItems === void 0 ? void 0 : configItems.availableDrillTargets;
    var drillItems = react_1.useMemo(function () {
        return availableDrillTargets
            ? drillConfigMapper_1.getMappedConfigForWidget(widgetDrills, availableDrillTargets, invalidCustomUrlDrillLocalIds)
            : [];
    }, [availableDrillTargets, widgetDrills, invalidCustomUrlDrillLocalIds]);
    var mergedItems = react_1.useMemo(function () { return mergeDrillConfigItems(drillItems, incompleteItems); }, [drillItems, incompleteItems]);
    var originSelectorItems = react_1.useMemo(function () { return getUnusedDrillTargets(availableDrillTargets, mergedItems); }, [availableDrillTargets, mergedItems]);
    var onSetupItem = react_1.useCallback(function (drill, changedItem) {
        var isNew = isItemNew(changedItem);
        dispatch(model_1.modifyDrillsForInsightWidget(widgetRef, [drill]));
        // we are not able remove incomplete items directly,it will change items in panel while command is processing
        // and this will not keep correct scroll.
        // we mark item complete and remove is done in useIncompleteItems when widget drills changed
        completeItem(changedItem);
        addSuccess(isNew ? messages.added : messages.modified, { duration: 3000 });
    }, [widgetRef, completeItem, addSuccess, isItemNew, dispatch]);
    var onDeleteItem = react_1.useCallback(function (item) {
        if (item.complete) {
            dispatch(model_1.removeDrillsForInsightWidget(widgetRef, [item]));
        }
        deleteIncompleteItem(item);
    }, [widgetRef, dispatch, deleteIncompleteItem]);
    return {
        widget: widget,
        enableKDZooming: enableKDZooming,
        drillConfigItems: mergedItems,
        originSelectorItems: originSelectorItems,
        isOriginSelectorVisible: !!(configItems === null || configItems === void 0 ? void 0 : configItems.availableDrillTargets),
        isLoaded: !!configItems,
        onChangeItem: onChangeItem,
        onOriginSelect: onOriginSelect,
        onSetupItem: onSetupItem,
        onDeleteItem: onDeleteItem,
    };
};
//# sourceMappingURL=useInsightDrillConfigPanel.js.map